<template>
  <div class="item-wrap">
    <div class="title">
      <!-- <el-tag>
        <slot name="tag" />
      </el-tag> -->
      <span class="text"> <slot name="title" /></span>
    </div>
    <slot name="content" />
    <div :class="`declare ${type}`">{{ status }}</div>
  </div>
</template>

<script>
export default {
  name: 'PolicyItem',
  props: {
    status: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
